import { useRouter } from 'next/router';

import { Button } from '@mui/material';

import parse from 'html-react-parser';

import MarketingNavigation from '../../../../../navigation/marketing';

export default function Confirmation() {
    const router = useRouter();

    const { confirmMessage, returnUrl, returnUrlLabel } = router.query;


    const handleClickReturn = () => {
        router.push(returnUrl);
    };

    return (
        <MarketingNavigation>
            <div className='flex flex-col w-fit text-xl relative mx-auto max-w-full py-8 px-6 lg:px-14'>
                <div className='self-center'>
                    {parse(confirmMessage ?? '')}
                </div>
                {returnUrl && (
                    <div className='w-fit'>
                        <Button
                            variant="contained" 
                            className='bg-secondary-500 hover:bg-secondary-500 whitespace-nowrap mt-5'
                            onClick={handleClickReturn}
                        >
                            {!returnUrlLabel ? 'Get Started' : returnUrlLabel}
                        </Button>
                    </div>
                )}
            </div>
        </MarketingNavigation>
    )
}

Confirmation.getLayout = page => <>{page}</>;
